webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(77),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(71),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Current__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Current___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Current__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LastTenFilms__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LastTenFilms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_LastTenFilms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageNotFound__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Resume__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Resume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Resume__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Home___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_2__components_About___default.a
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Contact___default.a
  }, {
    path: '/current',
    name: 'Current',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Current___default.a
  }, {
    path: '/last-ten-films',
    name: 'Last Ten Films',
    component: __WEBPACK_IMPORTED_MODULE_6__components_LastTenFilms___default.a,
    props: {
      listId: '22968',
      apiKey: '5e64db8b06cd51dc071b2933504a37c8'
    }
  }, {
    path: '/resume',
    name: 'Resume',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Resume___default.a
  }, {
    path: '*',
    name: 'Page Not Found',
    component: __WEBPACK_IMPORTED_MODULE_7__components_PageNotFound___default.a
  }]
}));

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(74),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(14);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageFooter__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageFooter__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    PageFooter: __WEBPACK_IMPORTED_MODULE_1__components_PageFooter___default.a
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Construction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Construction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Construction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageTitle__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {
      title: 'About me'
    };
  },

  components: {
    Construction: __WEBPACK_IMPORTED_MODULE_0__components_Construction___default.a,
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle___default.a
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'construction',
  data: function data() {
    return {
      title: '',
      msg: 'This page is under construction. Please come back later.'
    };
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PageTitle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      title: 'Contact me'
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default.a
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Construction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Construction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Construction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageTitle__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'current',
  data: function data() {
    return {
      title: 'Current projects'
    };
  },

  components: {
    Construction: __WEBPACK_IMPORTED_MODULE_0__components_Construction___default.a,
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle___default.a
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PageTitle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      title: 'Hi. I\'m Jonny.'
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default.a
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PageTitle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last-ten-films',
  props: {
    listId: {
      type: String,
      required: true
    },
    apiKey: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'Last ten films',
      films: [],
      tmdb: {
        secure_base_url: 'https://www.themoviedb.org/',
        secure_base_api_url: 'https://api.themoviedb.org/',
        api_key: this.apiKey,
        list_id: this.listId,
        config: null
      }
    };
  },
  created: function created() {
    var _this = this;

    this.axios.get(this.configurationUrl).then(function (response) {
      _this.tmdb.config = response.data;
      return _this.axios.get(_this.listUrl);
    }).then(function (response) {
      response.data.results.slice(0, 10).map(function (film) {
        _this.films.push(film);
      });
    }).catch(function (e) {
      console.log(e);
    });
  },

  methods: {
    filmUrl: function filmUrl(filmId) {
      return this.tmdb.secure_base_url + 'movie/' + filmId;
    },
    imageUrl: function imageUrl(relativePath) {
      return this.tmdb.config.images.secure_base_url + 'w500' + relativePath;
    }
  },
  computed: {
    configurationUrl: function configurationUrl() {
      return this.tmdb.secure_base_api_url + '3/configuration?api_key=' + this.tmdb.api_key;
    },
    listUrl: function listUrl() {
      return this.tmdb.secure_base_api_url + '4/list/' + this.tmdb.list_id + '?page=1&api_key=' + this.tmdb.api_key;
    }
  },
  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default.a
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      title: '',
      pages: {
        first: [{
          name: 'Home',
          to: '/'
        }, {
          name: 'About',
          to: '/about'
        }, {
          name: 'Current projects',
          to: '/current'
        }, {
          name: 'Resume',
          to: '/resume'
        }, {
          name: 'Contact',
          to: '/contact'
        }],
        second: [{
          name: 'Last ten films',
          to: '/last-ten-films'
        }]
      }
    };
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-footer',
  data: function data() {
    return {
      currentYear: new Date().getFullYear(),
      links: [{
        name: 'GitLab',
        href: 'https://gitlab.com/jonnypickett'
      }, {
        name: 'Github',
        href: 'https://github.com/jonnypickett'
      }, {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/in/jonathanpickett/'
      }, {
        name: 'Twitter',
        href: 'https://twitter.com/jonnypickett'
      }, {
        name: 'Instagram',
        href: 'https://www.instagram.com/jonnypickett/?hl=en'
      }]
    };
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PageTitle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-not-found',
  data: function data() {
    return {
      title: 'Page Not Found'
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default.a
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'title',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PageTitle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resume',
  data: function data() {
    return {
      title: 'Resume',
      pdfLink: 'https://jonnypickett.s3-us-west-1.amazonaws.com/current_resume.pdf'
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__components_PageTitle___default.a
  }
});

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/profile.jpg";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(69),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(67),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(72),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(70),
  /* scopeId */
  "data-v-178f9a15",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(78),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(68),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(76),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(73),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(75),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "contact-list"
    }
  }, [_c('li', [_vm._v("Phone: "), _c('a', {
    attrs: {
      "href": "tel:530-556-5605"
    }
  }, [_vm._v("530-556-5605")])]), _vm._v(" "), _c('li', [_vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:jonathan@studio308.co"
    }
  }, [_vm._v("jonathan@studio308.co")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:jonny@jonnypickett.com"
    }
  }, [_vm._v("jonny@jonnypickett.com")])]), _vm._v(" "), _c('li', [_vm._v("Company Site: "), _c('a', {
    attrs: {
      "href": "https://www.studio308.co"
    }
  }, [_vm._v("https://www.studio308.co")])])])
}]}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    attrs: {
      "id": "profile-pic-container"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/',
      "exact": ""
    }
  }, [_c('img', {
    attrs: {
      "id": "profile-pic",
      "src": __webpack_require__(57)
    }
  })])], 1), _vm._v(" "), _c('ul', [_vm._l((_vm.pages.first), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": link.to,
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.pages.second), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": link.to,
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('construction')], 1)
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('p', [_vm._v("This is the toplevel page of the jonnypickett site.")]), _vm._v(" "), _c('p', [_vm._v("I am a software engineer, a family man, a baseball fan, and an art appreciator.")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("I really love film. Take a look at the "), _c('router-link', {
    attrs: {
      "to": "/last-ten-films"
    }
  }, [_vm._v("last ten films")]), _vm._v(" I watched.")], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("The "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("about")]), _vm._v(" page goes into more detail about who I am."), _c('br'), _vm._v(" The "), _c('router-link', {
    attrs: {
      "to": "/current"
    }
  }, [_vm._v("current projects")]), _vm._v(" page details what I am currently working on,"), _c('br'), _vm._v(" and the "), _c('router-link', {
    attrs: {
      "to": "/resume"
    }
  }, [_vm._v("resume")]), _vm._v(" page has a link to my current resume to give a good overview of my experience.")], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Right now I'm really excited about serverless technologies. I've finally committed to understanding data modeling with NoSQL databases such as DynamoDB. Big ups to "), _c('a', {
    attrs: {
      "href": "https://www.alexdebrie.com",
      "target": "_blank"
    }
  }, [_vm._v("Alex DeBrie")]), _vm._v(" and his "), _c('a', {
    attrs: {
      "href": "https://www.dynamodbbook.com",
      "target": "_blank"
    }
  }, [_vm._v("\"The DynamoDB Book\"")]), _vm._v("."), _c('br'), _vm._v(" I get that engineering high off of working on decoupled, fault-tolerant systems. I'll probably try to convince you that we should use an event based microservice approach as a way to reduce points of failure.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("My favorite baseball team is the "), _c('a', {
    attrs: {
      "href": "https://cdn.kqed.org/wp-content/uploads/sites/10/2014/10/RS12812_458071300-scr.jpg",
      "target": "_blank"
    }
  }, [_vm._v("San Francisco Giants")]), _vm._v(", and yes, the National League is the best league.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("My favorite painting is "), _c('a', {
    attrs: {
      "href": "https://collections.lacma.org/node/233733",
      "target": "_blank"
    }
  }, [_vm._v("Joan Mitchell's East Ninth Street")]), _vm._v(" on display at LACMA.")])
}]}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('construction')], 1)
},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('p', [_vm._v("I'm sorry, but the page you are looking for could not be found.")])], 1)
},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navigation'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('page-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1000px"
    }
  }, [_c('object', {
    attrs: {
      "data": _vm.pdfLink,
      "height": "100%",
      "width": "100%",
      "type": "application/pdf"
    }
  }, [_c('p', [_vm._v("This browser does not support PDFs. Please download the PDF to view it: \n"), _c('a', {
    attrs: {
      "href": _vm.pdfLink
    }
  }, [_vm._v("Download PDF")]), _vm._v(".")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-footer"
    }
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Links")]), _vm._v(" "), _c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', {
      key: link.name
    }, [_c('a', {
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Copyright © " + _vm._s(_vm.currentYear) + " by "), _c('a', {
    attrs: {
      "href": "https://www.studio308.co"
    }
  }, [_vm._v("Studio 308")])])])
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _vm._l((_vm.films), function(film) {
    return _c('div', {
      key: film.id,
      staticClass: "film"
    }, [_c('a', {
      attrs: {
        "href": _vm.filmUrl(film.id),
        "target": "_blank"
      }
    }, [(_vm.tmdb.config) ? _c('img', {
      attrs: {
        "src": _vm.imageUrl(film.backdrop_path)
      }
    }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v("\n    " + _vm._s(film.original_title) + "\n  ")])
  })], 2)
},staticRenderFns: []}

/***/ })
],[34]);


// WEBPACK FOOTER //
// static/js/app.js?v=1.8.2